/* eslint-disable jsx-a11y/href-no-hash */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import ShowComponent from './../hocs/ShowComponent';

@ShowComponent
@observer
class ShowProvidersComponent extends React.Component {
  constructor(props) {
    super(props);

    this.toggleShowAllProviders = this.toggleShowAllProviders.bind(this);
  }

  toggleShowAllProviders(e) {
    const { toggleShowAllProviders } = this.props.storeData;

    e.preventDefault();

    toggleShowAllProviders();
  }

  render() {
    const { showAllProviders } = this.props.storeData;
    const { labelInterests } = this.props;
    let component;

    if (showAllProviders) {
      component = (
        <a className="overview-container__show-all-providers" href="#" onClick={this.toggleShowAllProviders} >
         Toon de top 10 aanbieders
        </a>
     );
    } else {
      component = (
        <a className="overview-container__show-all-providers" href="#" onClick={this.toggleShowAllProviders} >
          Toon alle {labelInterests.length} aanbieders
        </a>
     );
    }

    return (
      component
    );
  }
}

ShowProvidersComponent.propTypes = {
  labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
  storeData: PropTypes.shape({
    toggleShowAllProviders: PropTypes.func,
    showAllProviders: PropTypes.bool,
  }),
};

ShowProvidersComponent.defaultProps = {
  labelInterests: [],
  storeData: {
    toggleShowAllProviders: () => {},
    showAllProviders: false,
  },
};

export default ShowProvidersComponent;
